module.exports = __webpack_public_path__ + "img/pinceimgfa3.fbbe97bc.png";